/**
 * MobileTeacherResources — mobile variant of /me/resources.
 *
 * BON-96: content-authoring has no source yet (separate track — BON-66), so
 * the surface renders the design's three modules (Training & certifications,
 * Library, What's new) as an em-dash skeleton behind a single <MockedOverlay>,
 * mirroring the desktop bucket. It lights up when the content model ships.
 */
import { MockedOverlay } from '../primitives';
import { BucketError, BucketLoading } from '../regional/BucketStates';
import { useTeacherResources } from '../teacher/teacherApi';

import MobileMockedModuleCard from './components/MobileMockedModuleCard';
import MobileSurface from './MobileSurface';

const MODULES = ['Training & certifications', 'Library', 'What’s new'] as const;

export default function MobileTeacherResources() {
  const q = useTeacherResources();

  if (q.isLoading) {
    return (
      <MobileSurface title="Library" subtitle="Loading…">
        <BucketLoading />
      </MobileSurface>
    );
  }
  if (q.isError) {
    return (
      <MobileSurface title="Library" subtitle="Couldn’t load">
        <BucketError error={q.error} />
      </MobileSurface>
    );
  }
  if (!q.data) return null;

  return (
    <MobileSurface title="Library" subtitle="Scripts, care guides & policies">
      <MockedOverlay reason="Teaching resources aren’t wired up yet. Goes live once the content-authoring story ships — tracked in BON-66.">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {MODULES.map((m) => (
            <MobileMockedModuleCard key={m} title={m} />
          ))}
        </div>
      </MockedOverlay>
    </MobileSurface>
  );
}
